import { Injectable, Injector, ComponentFactoryResolver } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbModalStack } from '@ng-bootstrap/ng-bootstrap/modal/modal-stack';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap/modal/modal';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import { Subject } from 'rxjs/Subject';
import { NewSubscriptionServiceDataProvider } from '@services/subscription/subscription.service';
import { PlatformLocation } from '@angular/common';
import { Subscription } from 'rxjs/Subscription';

@Injectable()
export class SNModalService extends NgbModal {
	readonly snModalConfig: NgbModalOptions = {
		windowClass: 'ng-bootstrap-modal',
		backdropClass: 'ng-bootstrap-backdrop',
		backdrop: 'static',
		keyboard: false
	};
	modalData: Subject<any> = new Subject<any>();
	activeModal: NgbModalRef;

	constructor(
		private componentFactoryResolver: ComponentFactoryResolver,
		private injector: Injector,
		private modalStack: NgbModalStack,
		private subscriptionService: NewSubscriptionServiceDataProvider,
		private location: PlatformLocation
	) {
		super(componentFactoryResolver, injector, modalStack);
		location.onPopState(() => {
			try {
				this.closeActiveModal()
			} catch (error) {
				console.error(error);
			}
		});
	}

	openModal(content: any, config?: NgbModalOptions): NgbModalRef {
		this.activeModal = super.open(
			content,
			Object.assign(JSON.parse(JSON.stringify(this.snModalConfig)), config)
		);
		return this.activeModal;
	}

	setModalData(data: any) {
		this.modalData.next(data);
	}

	getModalData() {
		return this.modalData.asObservable();
	}

	closeModalByRef(modalRef: NgbModalRef, modalDataStream: Subscription): void {
		modalRef.dismiss();
		if (modalDataStream) {
			modalDataStream.unsubscribe();
		}
	}

	closeActiveModal(): void {
		if (this.activeModal) {
			this.subscriptionService.setChoosePlanOpenModalStatus({
				state: false,
				payload: null
			});
			this.activeModal.dismiss();
			this.activeModal = null;
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/services/modal/snModal.service.ts